import React from "react";
import underConstructionLottie from "../../assets/animations/under-contruction-animation.json";
import Lottie from "lottie-react";
import { Link } from "react-router-dom";
import "./under-construction.css";

const UnderContruction = () => {
  return (
    <div className="under-construction">
      <div className="lottie-wrapper">
        <Lottie animationData={underConstructionLottie} loop={true} />
      </div>
      <h1>Oops! This page is under construction.</h1>
      <p>don't worry we will be back soon, untill then explore the projects</p>
      <button
        style={{
          padding: "24px 40px",
          backgroundColor: "black",
          color: "white",
          borderRadius: "50px",
          border: "none",
        }}
      >
        <Link style={{ color: "white", textDecoration: "none" }} to="/">
          View Projects
        </Link>
      </button>
    </div>
  );
};

export default UnderContruction;
